import React from "react";
import WorkPlace from "../HomePage/WorkPlace/WorkPlace";
import store from "store";
import AccountAction from '../../containers/AccountAction/AccountAction';


const isLoggedIn = store.get("isLoggedIn");

const homePage = () => {
  if (isLoggedIn === false) {
    return <AccountAction/>
  }else{
    return (
      <div className ="HomePage"> 
          <WorkPlace/>       
      </div>
    )
  }
  
};

export default homePage;
